/**
 * CSV Export Button component with icon
 */

import { useState } from 'react'
import { exportData } from '@/services/api/importExport'
import { Button } from '@/components/ui/button'
import { IconDownload, IconLoader2 } from '@tabler/icons-react'

interface CSVExportButtonProps {
  type: 'assets' | 'sales' | 'all'
  label?: string
}

export function CSVExportButton({ type, label }: CSVExportButtonProps) {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    setIsExporting(true)
    try {
      await exportData(type)
      // Success handled by download
    } catch (error) {
      console.error('Export failed:', error)
      alert('Không thể xuất dữ liệu. Vui lòng thử lại.')
    } finally {
      setIsExporting(false)
    }
  }

  const defaultLabel = type === 'assets' ? 'Xuất Tài sản' : type === 'sales' ? 'Xuất Giao dịch Bán' : 'Xuất Tất cả'

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting}
      className="min-h-[44px]"
    >
      {isExporting ? (
        <>
          <IconLoader2 className="h-4 w-4 mr-2 animate-spin" stroke={1.5} />
          Đang xuất...
        </>
      ) : (
        <>
          <IconDownload className="h-4 w-4 mr-2" stroke={1.5} />
          {label || defaultLabel}
        </>
      )}
    </Button>
  )
}

